import logoWhiteUrl from "@assets/logo-white.png";
import useSearchParam from "@hooks/useSearchParam";
import { AppBar, Box, CircularProgress, Container, Toolbar } from "@mui/material";
import { mutationErrorHandler } from "@services/relay/utils";
import { useEffect, type FC } from "react";
import { graphql, useMutation } from "react-relay";
import { navigate } from "wouter/use-browser-location";

import { type LoginCallbackMutation } from "./__generated__/LoginCallbackMutation.graphql";

const mutation = graphql`
  mutation LoginCallbackMutation($input: BrandLoginCallbackInput!) {
    brandLoginCallback(input: $input) {
      ok
    }
  }
`;

const LoginCallback: FC = () => {
  const [userId] = useSearchParam("user");
  const [code] = useSearchParam("code");
  const [next] = useSearchParam("next");
  const [commitMutation, mutationLoading] = useMutation<LoginCallbackMutation>(mutation);

  useEffect(() => {
    // Use timeout to prevent duplicated effect executions
    const timeoutId = setTimeout(() => {
      commitMutation({
        variables: { input: { userId: userId ?? "", code: code ?? "" } },
        onCompleted: () => {
          const to = next ?? "/";
          navigate(to, { replace: true });
        },
        onError: mutationErrorHandler,
      });
    }, 50);

    return () => {
      clearTimeout(timeoutId);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box>
      <AppBar position="static" sx={{ px: 2 }}>
        <Toolbar disableGutters>
          <img src={logoWhiteUrl} alt="logo" height={33} width={160} />
        </Toolbar>
      </AppBar>

      <Container>
        <Box sx={{ pt: "30vh", display: "flex", justifyContent: "center" }}>
          {mutationLoading && <CircularProgress size={20} />}
        </Box>
      </Container>
    </Box>
  );
};

export default LoginCallback;
